var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button paddingSize",style:({
		marginTop: _vm.data.marginTop + 'px',
	})},[(_vm.data.content)?_c('div',{staticClass:"btn",style:({
			color: _vm.data.textColor,
			backgroundColor: _vm.data.textBackgroundColor,
			paddingTop: _vm.data.paddingTop + 'px',
		}),on:{"click":_vm.butClick}},[_vm._v(" "+_vm._s(_vm.data.content)+" ")]):_c('div',{staticClass:"btn"},[_vm._v("默认按钮")])])}
var staticRenderFns = []

export { render, staticRenderFns }